import { TableRowType } from "./brief-list-table/table-row-type.enum";
import { TableSectionType } from "./brief-list-table/table-section-type.enum";

export const BriefListTodayHeader = {
  type: TableRowType.HEADER_CELL,
  section: TableSectionType.TODAY,
  name: "Today",
};

export const BriefListPrevSevenDaysHeader = {
  type: TableRowType.HEADER_CELL,
  section: TableSectionType.PREVIOUS_SEVEN,
  name: "Previous 7 Days",
};

export const BriefListBeforeSevenDaysHeader = {
  type: TableRowType.HEADER_CELL,
  section: TableSectionType.EARLIER,
  name: "Earlier",
};
